import { action, observable } from 'mobx';
import { api } from '../config';
import 'whatwg-fetch';

// Components
import SessionStore from './SessionStore';

// Dependencies
import moment from 'moment';

var obx = observable({
  exam: {
    title: '',
    type: "Online",
    description: '',
    useProctorManager: false,
    requireApproval: false,
    url: '',
    enableAppointmentSuggestions: false,
    configuration: {
      examOpenDate: '',
      examCloseDate: '',
      scheduleOpenDate: '',
      scheduleCloseDate: '',
      password: '',
      duration: 0,
      attempts: 1,
      requiredSoftware: '',
      studentNotes: '',
      proctorNotes: '',
      proctorTypes: []
    }
  },
  configuration: null,
  // Reset exam data
  resetExam: action(function () {
    obx.exam = {
      title: '',
      type: "Online",
      description: '',
      useProctorManager: false,
      requireApproval: false,
      url: '',
      enableAppointmentSuggestions: false,
      configuration: {
        examOpenDate: '',
        examCloseDate: '',
        scheduleOpenDate: '',
        scheduleCloseDate: '',
        password: '',
        duration: 0,
        attempts: 1,
        requiredSoftware: '',
        studentNotes: '',
        proctorNotes: '',
        proctorTypes: [],
        permittedBathroomBreak: false,
        permittedBathroomBreakInformation: '',
        permittedBlankPaper: false,
        permittedBlankPaperInformation: '',
        permittedCalculator: false,
        permittedCalculatorInformation: '',
        permittedDictionary: false,
        permittedDictionaryInformation: '',
        permittedEarplugs: false,
        permittedEarplugsInformation: '',
        permittedFormulaSheet: false,
        permittedFormulaSheetInformation: '',
        permittedNotes: false,
        permittedNotesInformation: '',
        permittedOtherItems: '',
        permittedTextbook: false,
        permittedTextbookInformation: '',
        permittedWebsites: false,
        permittedWebsitesInformation: '',
        instructorAsProctor: []
      }
    }
  }),
  // Get a specific exam
  getExam: action(function(sid) {
    SessionStore.startLoading('Loading…', 'Exam');
    obx.resetExam();

    api.get(`/installs/${SessionStore.userData.installSid}/courses/${SessionStore.userData.courseSid}/exams/${sid}`)
      .then(response => {
        obx.exam = response.data;
        obx.defaultExam = response.data;
        SessionStore.finishLoading('Exam');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Reset custom configuration data
  resetConfigurationData: action(function () {
    obx.customConfiguration = null;
  }),
  // Get custom configuration data
  getConfigurationData: action(function (examSid, sid) {
    SessionStore.startLoading('Loading…', 'GetConfiguration');
    obx.resetConfigurationData();

    api.get(`/installs/${SessionStore.userData.installSid}/courses/${SessionStore.userData.courseSid}/exams/${examSid}/configurations/${sid}`)
      .then(response => {
        obx.configuration = response.data;
        SessionStore.finishLoading('GetConfiguration');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get incident types
  incidentTypes: [],
  incidentSid: null,
  incidentSession: null,
  getIncidentTypes: action(function(){
    SessionStore.startLoading('Loading…', 'GetIncidentTypes');

    obx.incidentTypes = [];

    api.get(`/sessions/events/types`)
      .then(response => {
        obx.incidentTypes = response.data.results;
        SessionStore.finishLoading('GetIncidentTypes');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Create session incident
  createSessionEvent: action(function(installSid, examSid, sessionSid, data, callback){
    SessionStore.startLoading('Loading…', 'CreateSessionEvent');

    api.post(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/events`, data)
      .then( () => {
        // obx.getSessionEvents(installSid, examSid, sessionSid);
        SessionStore.finishLoading('CreateSessionEvent');

        obx.getSessionEvents(installSid, examSid, sessionSid);

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Update session incident
  updateSessionEvent: action(function(installSid, examSid, sessionSid, eventSid, data, callback){
    SessionStore.startLoading('Loading…', 'UpdateSessionEvent');

    delete data.sid;
    delete data.examSessionSid;
    delete data.createdDate;
    delete data.eventType;

    api.put(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/events/${eventSid}`, data)
      .then( () => {
        // obx.getSessionEvents(installSid, examSid, sessionSid);
        obx.incidentSid = null;
        SessionStore.finishLoading('UpdateSessionEvent');

        obx.getSessionEvents(installSid, examSid, sessionSid);

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Delete session incident
  deleteSessionEvent: action(function(installSid, examSid, sessionSid, eventSid){
    SessionStore.startLoading('Loading…', 'DeleteSessionEvent');

    api.delete(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/events/${eventSid}`)
      .then( () => {
        SessionStore.finishLoading('DeleteSessionEvent');
        obx.getSessionEvents(installSid, examSid, sessionSid);
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get a specific incident
  incident: {},
  getSingleSessionEvent: action(function(installSid, examSid, sessionSid, incidentSid, component) {
    SessionStore.startLoading('Loading…', 'GetSpecificEvent');

    obx.incident = {};

    return api.get(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/events/${incidentSid}`)
      .then(response => {
        obx.incident = response.data;

        if(component) {
          component.setState({
            incidentData: response.data
          })

          // Make sure date is the right format
          let incidentData = {...component.state.incidentData};
          incidentData.eventTime = response.data.eventTime;

          component.setState({
            incidentData
          });
          component.setState({
            date: moment(response.data.eventTime)
          });
        }

        SessionStore.finishLoading('GetSpecificEvent');
        return response.data
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get incidents for a session
  sessionEvents: [],
  getSessionEvents: action(function(installSid, examSid, sessionSid, backgroundLoad) {
    if(!backgroundLoad) {
      SessionStore.startLoading('Loading…', 'GetSessionEvents');
    } else {
      SessionStore.startBackgroundLoading('GetSessionEvents');
    }

    obx.sessionEvents = [];

    api.get(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/events`)
      .then(response => {
        obx.sessionEvents = response.data.results;

        if(!backgroundLoad) {
          SessionStore.finishLoading('GetSessionEvents');
        } else {
          SessionStore.finishBackgroundLoading('GetSessionEvents');
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
});

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/ExamStore.js